import { FC } from 'react';

import { Levels } from '_core/utils/public-links/_types';

import { ExploreDropdownToggle } from '../types';
import { LinksSection } from './links-section.component';

type Props = {
  addToRefs: (el: HTMLDivElement | HTMLHeadingElement) => void;
  exploreServicesByName: Levels | undefined;
  exploreServicesByLocationMain: Levels | undefined;
  exploreServicesByLocationOthers: Levels | undefined;
  isOpenServices: ExploreDropdownToggle | undefined;
  openDropdown: (param: string) => void;
  selectedId: string;
  subtitle: string;
};

export const ExploreMainSection: FC<Props> = (props) => {
  const {
    addToRefs,
    subtitle,
    exploreServicesByName,
    exploreServicesByLocationMain,
    exploreServicesByLocationOthers,
    openDropdown,
    isOpenServices,
    selectedId,
  } = props;
  return (
    <div className="layout-column flex-1 flex-gt-sm-66 sm:mb-32 max-sm:mb-16 mr-4">
      <h2 className="h3 mb-4 bold">{subtitle}</h2>

      {exploreServicesByName && <LinksSection category={exploreServicesByName} showDropdown={false} ref={addToRefs} />}

      {exploreServicesByLocationMain && (
        <LinksSection
          showDropdown
          category={exploreServicesByLocationMain}
          openDropdown={openDropdown}
          isOpenServices={isOpenServices}
          selectedId={selectedId}
          ref={addToRefs}
        />
      )}
      {exploreServicesByLocationOthers && (
        <LinksSection
          category={exploreServicesByLocationOthers}
          hideCategory
          showDropdown
          openDropdown={openDropdown}
          isOpenServices={isOpenServices}
          selectedId={selectedId}
          ref={addToRefs}
        />
      )}
    </div>
  );
};
